import HelpInfoWrapper from '../../../../help-info-wrapper';

import CostColumnHeader from './costColumnHeader';

const CostColumnHeaderWithInfo = () => (
  <HelpInfoWrapper
    tooltip={
      <>
        <p>Funds are only charged for a success operations.</p>
        <p>Funds for a failed operations are returned.</p>
        <p>
          Funds for an unknown operations are reserved and not confirmed yet - they may be returned or confirmed,
          depending on the operation&apos;s final state: success or failure.
        </p>
      </>
    }
  >
    <CostColumnHeader />
  </HelpInfoWrapper>
);

export default CostColumnHeaderWithInfo;
